// couponService.ts
export const KP11LinkCouponService = {
  async validateObFeeCoupon(client, couponCode, country = 'US') {
    return client(
      `orders/coupon/validate?couponCode=${couponCode}&country=${country}`,
    )
  },

  async validateCouponByPlans(
    client,
    couponCode,
    planCode = [],
    selectedCountry = 'US',
  ) {
    return client(
      `orders/coupon/validate?couponCode=${couponCode}&country=${selectedCountry}&planCode=${planCode.join()}&addonsString=${planCode.join()}`,
    )
  },

  async fetchIncentivesByPlans(
    client,
    codes = [],
    country = 'US',
    clientGroup = 'null',
    thryvAccount = 'null',
  ) {
    if (!codes.length) return null
    return client(
      `cc/order/fetchPlanCoupons/${country}/${codes.join(',')}/${clientGroup}/${
        thryvAccount?.recurlyAccount?.code || 'null'
      }`,
    )
  },

  async fetchPromoCodeBySearchText(client, searchText, selectedCountry = 'US') {
    return client(`cc/order/fetchCoupons/${selectedCountry}/${searchText}`)
  },
}
